<template>
    <div class="ffz">
        <searchtop placeholder="请输入食物名称搜索" @doSearch="doSearch"></searchtop>
        <div class="ftop">
            <div class="nm">
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                    <van-list
                        v-model="navitem.loaded"
                        :finished="navitem.loadingType == 'nomore' ? true : false"
                        :finished-text="navitem.loadingType == 'nomore' ? '没有更多了' : '下拉加载更多'"
                        @load="loadData">
                            <div v-for="(item,index) in navitem.list" :key="index">
                                <foodcom :item="item"></foodcom>
                            </div>
                    </van-list>
                </van-pull-refresh>
            </div>
            

        </div>
         
    </div>
</template>
<script>
import searchtop from '@/components/search/searchtop.vue';
export default {
    components:{
        searchtop
    },
    data(){
        return{
            navitem: {
                isfirst:true,
                loadingType: "more",
                loaded: false,
                getparams: {
                    sorting: " sorter desc,id desc",
                    maxResultCount: 10,
                    skipCount: 0,
                    title:undefined
                },
                list: [],
            },
            loading: false,
            finished: false,
            refreshing: false,
        }
    },
    // beforeCreate(){
    //     document.querySelector('body').setAttribute('style', 'background-color:#fff')
    // },
    // destroyed(){
    //     document.querySelector('body').removeAttribute("style");
    // },
    created(){

    },
    methods:{
        goto(url,item){
            this.$router.push({path:url,query:{id:item.id}});
        },
        onRefresh() {
            this.loadData("refresh");
        },
        doSearch(val){
            if(val)
            {
                this.navitem.getparams.title=val;
                this.loadData('refresh');
            }
            else
            {
                this.$toast.success({type:'html',message:'请输入查询内容'});
            }
            
        },
        loadData(source) {
        if(this.navitem.isfirst)
        {
            this.refreshing = false;
            this.$set(this.navitem, "loaded", false);
            this.navitem.isfirst=false;
            return;
        }
        let navItem = this.navitem;
        // let state = navItem.state;

        if (source === "tabChange" && navItem.loaded === true) {
            //tab切换只有第一次需要加载数据
            return;
        }
        if (navItem.loadingType === "loading" || navItem.loadingType === "nomore") {
            //防止重复加载
            if (source != "refresh") {
            return;
            }
        }
        if (source === "refresh") {
            this.navitem.list = [];
            this.navitem.getparams.skipCount = 0;
        }
        navItem.loadingType = "loading";
        var params = navItem.getparams;
        
        //加载数据
        this.ajax
            .post("/api/services/app/PhoneEat/QueryEatProductPageList", params)
            .then((x) => {
            this.navitem.getparams.skipCount += this.navitem.getparams.maxResultCount;
            let totalcount = x.result.totalCount;
            this.navitem.list = this.navitem.list.concat(x.result.items);
            //console.log(this.navList);
            // item = Object.assign(item, this.orderStateExp(item.state));
            this.navitem.loadingType =
                totalcount > this.navitem.getparams.skipCount ? "more" : "nomore";
            })
            .finally(() => {
            this.$set(this.navitem, "loaded", false);
            this.refreshing = false;
            });
        },
    }
}
</script>
<style lang="scss" scoped>
.ffz{
    font-size: 12px;
    background-color: #fff;
}
.ftop{
    margin-top:5px;
    margin-left: 5px;
    margin-right:5px;
}
.nm{
    width: 100%;
    height: 100%;
}
</style>